import configModule from '../../../../temp/config.js';
const config = configModule.default || configModule;

const TOKEN_URL = config.TOKEN_URL;

const tokenCache = {};

// Resolve credentials based on vehicle category
const getCredentialsByCategory = (vehicleCategory) => {
  if (!vehicleCategory) {
    throw new Error('Vehicle category is required');
  }

  const normalized = vehicleCategory.toLowerCase();

  if (normalized.includes('2')) {
    return {
      clientId: config.TVS_2W_CLIENT_ID,
      clientSecret: config.TVS_2W_SECRET_ID,
    };
  }

  if (normalized.includes('3')) {
    return {
      clientId: config.TVS_3W_CLIENT_ID,
      clientSecret: config.TVS_3W_SECRET_ID,
    };
  }

  throw new Error(`No credentials mapped for ${vehicleCategory}`);
};

export async function getAccessToken(brandId, vehicleCategory) {
  if (!brandId) throw new Error('BrandId is required');

  const now = Date.now();
  const cacheKey = `${brandId}_${vehicleCategory}`;

  if (!tokenCache[cacheKey]) {
    tokenCache[cacheKey] = { token: null, expiresAt: 0 };
  }

  if (tokenCache[cacheKey].token && now < tokenCache[cacheKey].expiresAt) {
    return tokenCache[cacheKey].token;
  }

  const { clientId, clientSecret } = getCredentialsByCategory(vehicleCategory);

  const url =
    `${TOKEN_URL}?grant_type=client_credentials` +
    `&client_id=${clientId}` +
    `&client_secret=${clientSecret}`;

  const response = await fetch(url, { method: 'POST' });
  const data = await response.json();

  tokenCache[cacheKey] = {
    token: data.access_token,
    expiresAt: now + (data.expires_in - 60) * 1000,
  };

  return data.access_token;
}
